import Box from '@mui/material/Box';
import { Button } from '../buttons/button';
import { BodyS } from '../../../typography';
import { Caption } from '../../../typography';
import { useFeatureCalloutStyles } from './featureCallout.styles';

import type { CSSProperties, JSX, ReactNode } from 'react';

type FeatureCalloutProps = {
  icon?: JSX.Element;
  title: ReactNode;
  description?: ReactNode;
  actionText: string;
  actionButtonWidth?: CSSProperties['width'];
  onClick: () => void;
  type: 'upgrade' | 'beta';
};

export const FeatureCallout = ({
  icon,
  title,
  description,
  actionText,
  actionButtonWidth = 100,
  onClick,
  type,
}: FeatureCalloutProps): JSX.Element | null => {
  const styles = useFeatureCalloutStyles({ type });

  return (
    <Box role='alert' css={styles.container}>
      <Box css={styles.content}>
        {icon && <Box css={styles.iconContainer}>{icon}</Box>}

        <Box css={styles.text}>
          <BodyS fontWeight='medium' css={styles.title}>
            {title}
          </BodyS>
          {Boolean(description) && (
            <Caption css={styles.description}>{description}</Caption>
          )}
        </Box>
      </Box>

      <Box>
        <Button
          type={type === 'upgrade' ? 'upgrade' : 'primary'}
          size='small'
          onClick={onClick}
          width={actionButtonWidth}
        >
          {actionText}
        </Button>
      </Box>
    </Box>
  );
};
